var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'margin-top-0': _vm.$route && _vm.$route.name === 'StartseiteArvea' },attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }